import { setAllFarms } from 'farms';

export const processAllFarms = ({ dispatch, farms }) => {
  return Promise.resolve()
  .then( () => {
    dispatch(setAllFarms(farms));
    return farms;
  });
};


